import React from 'react';

// Jaring pengaman untuk render error sinkron (mis. `authUser.fullName` saat
// authUser sudah null di tengah transisi logout) -- ini TIDAK tertangkap
// oleh globalErrorHandler.js (yang hanya menangani unhandledrejection).
// Tanpa boundary ini, satu error render di mana pun akan meng-unmount
// seluruh React root -> layar putih kosong yang butuh refresh manual.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled render error:', error, info);
  }

  handleReload = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className='d-flex flex-column justify-content-center align-items-center vh-100 text-center px-3'>
          <i className='bi bi-exclamation-triangle-fill text-warning fs-1 mb-3'></i>
          <h5 className='fw-bold mb-2'>Terjadi kesalahan tak terduga</h5>
          <p className='text-muted mb-3'>
            Silakan muat ulang halaman untuk melanjutkan.
          </p>
          <button
            type='button'
            className='btn btn-primary'
            onClick={this.handleReload}
          >
            Muat Ulang
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
